// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { awBorderGrey } from 'Utils/themes';

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${awBorderGrey}`,
    borderRadius: '12px',
    padding: theme.spacing(5, 2),
    marginTop: theme.spacing(2),
  },
  iconBadge: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#E5EAEE',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(1.5),
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.5143px',
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.5143px',
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
});

export default styles;
